import React, {useMemo} from "react";
import {MapObject} from "../../../../../Server/DB/mapObjects/@MapObject.js";
import {DMap} from "../../../../../Server/DB/maps/@Map.js";
import {MapState} from "../../../../../Store/main/maps/@MapState.js";
import {observer_mgl_r3} from "../../../../../Utils/ThreeJS/General.js";
import {Vec2} from "../../../../../Utils/ThreeJS/VectorStructs.js";
import {store} from "../../../../../Store/index.js";
import {ObjPath} from "../../../../../Server/DB/mapObjects/@MapObject/ObjPath.js";
import {ResolvePathMeshes} from "../../../../../Server/DB/mapObjects/@MapObject/ObjPath/ObjPathResolvers.js";
import {PathMeshUI} from "./PathMeshUI.js";

export const PathUI = observer_mgl_r3((props: {path: ObjPath, obj: MapObject, map: DMap, mapState: MapState})=>{
	const {path, obj, map} = props;
	const pathIndex = obj.paths.indexOf(path);
	const toolState = store.main.maps.tools.toolStates.pathModify;

	const pendingPathUpdatesHere = toolState.pendingObjPathUpdates.get(obj.id)?.pathIndex == pathIndex ? toolState.pendingObjPathUpdates.get(obj.id) : null;

	// Pending edits take precedence: temporarily show just the edited literal points (hiding
	// any derived-path polygons until the edit completes).
	const pathAndObj_final = useMemo(()=>{
		if (pendingPathUpdatesHere == null) return {path, obj};
		const path_final = {...path, points: pendingPathUpdatesHere.NewPoints()};
		// reconstruct `obj_final` to include `path_final`, so `obj.paths.indexOf(path)` works downstream
		const paths_final = [...obj.paths];
		paths_final[pathIndex] = path_final;
		const obj_final = {...obj, paths: paths_final};
		return {path: path_final, obj: obj_final};
	}, [pendingPathUpdatesHere, path, obj, pathIndex]);
	const resolvedMeshes = ResolvePathMeshes(pathAndObj_final.path, pathAndObj_final.obj);
	const pointSets = resolvedMeshes?.meshes.map(a=>a.map(b=>Vec2.FromSimple(b))) ?? [];
	const pointSetsClosed = !!resolvedMeshes?.closed; // if resolvedMeshes is null, just say "closed=false" (doesn't matter)

	if (pointSets.length == 0) return null;
	return (
		<>
			{pointSets.map((pts, i)=><PathMeshUI key={i}
				path={pathAndObj_final.path} obj={pathAndObj_final.obj} map={map}
				pathIndex={pathIndex} points={pts} pointsClosed={pointSetsClosed}/>)}
		</>
	);
});